export default __webpack_public_path__ + "static/media/lang_es.6dfd1769.png";